import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, TemplateRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { SkeletonTemplateService } from '@skeleton-loader';
import { AccessibleClickDirective } from '../directives';

@Component({
  selector: 'lib-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, MatExpansionModule, AccessibleClickDirective],
})
export class ExpansionPanelComponent {
  title = input<string | TemplateRef<unknown>>();
  content = input<string | TemplateRef<unknown> | Array<{ text: string; order: 0 } | any>>();
  isExpanded = input(true);
  isExpandable = input(true);

  skeletonService = inject(SkeletonTemplateService);

  vm = computed(() => ({
    title: this.title() as string,
    titleTemplate: this.title() as TemplateRef<unknown>,
    content: this.getContentFormatted(this.content()),
    contentTemplate: this.content() as TemplateRef<unknown>,

    isTitleTemplate: this.title() instanceof TemplateRef,
    isContentTemplate: this.content() instanceof TemplateRef,
    isExpanded: this.isExpanded(),
    isLoadingContent: !this.content(),
  }));
  isArrayOfObjectsProvided = computed(() => Array.isArray(this.content()));

  isDisplayComponent = computed(() => {
    if (this.vm().isContentTemplate) {
      return true;
    }

    const vm = this.vm();
    const isLoadingContent = vm.isLoadingContent;
    const content = vm.content;
    const isArrayWithContent = Array.isArray(content) && !!content?.length;
    const isNonArrayWithContent = !!content && !Array.isArray(content);

    return !isLoadingContent && (isArrayWithContent || isNonArrayWithContent);
  });

  getContentFormatted(arg: string | TemplateRef<unknown> | Array<{ text: string; order: 0 }> | any): any {
    if (typeof arg === 'string') {
      return arg;
    }
    if (Array.isArray(arg)) {
      return (arg as Array<{ text: string; order: 0 }>).sort((a, b) => a.order - b.order).map((item) => item.text);
    }

    return '';
  }
}
